import { createContext, useCallback, useContext } from 'react';
import PortalIdParser from 'PortalIdParser';
import { getContentPropertyValue, CONTENT_PLATFORM_PROPERTY_NAME } from 'content-management-data-lib';
import useGetAPI from '../hooks/useGetAPI';
import { jsx as _jsx } from "react/jsx-runtime";
const useFetchContentSettings = () => {
  const {
    requestStatus,
    responseData
  } = useGetAPI('fetch-content-settings', `content-settings/v1/site-settings/by-portal-id/${PortalIdParser.get()}`);
  const getBodyOverrideSettingByContentObjectDomain = useCallback((contentObject, settingName) => {
    const domain = getContentPropertyValue(contentObject, CONTENT_PLATFORM_PROPERTY_NAME.DOMAIN);
    const bodyOverrideForDomain = domain && responseData && Object.keys(responseData).length > 0 ? responseData.bodyOverrideByDomain[domain] : null;
    return bodyOverrideForDomain && bodyOverrideForDomain[settingName];
  }, [responseData]);
  return {
    requestStatus,
    getBodyOverrideSettingByContentObjectDomain
  };
};
export const ContentSettingsContext = /*#__PURE__*/createContext(undefined);
const ContentSettingsDataProvider = ({
  children
}) => {
  const value = useFetchContentSettings();
  return /*#__PURE__*/_jsx(ContentSettingsContext.Provider, {
    value: value,
    children: children
  });
};
export default ContentSettingsDataProvider;
export function useContentSettingsData() {
  const context = useContext(ContentSettingsContext);
  if (context === undefined) {
    throw new Error('useContentSettingsData must be used within a ContentSettingsDataProvider');
  }
  return context;
}